import Vue from 'vue';
import App from '../coupon-popup/app';

export const initCouponPopup = () => {
  const targetId = 'fc-popup';
  if (!document.getElementById(targetId)) return;

  const env = process.env.NODE_ENV;
  const initProps = {
    props: {
      env,
      slug: location.pathname.split('/')[1],
      type: 'alert', // alert, confirm, prompt, custom
    },
  };

  new Vue({
    render: (h) => h(App, initProps),
  }).$mount(`#${targetId}`);
};
